import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'

export const Container = styled(Flex)`
  // padding: 20px 25px;
  border-bottom: 1px solid ${COLORS.GREY_T_90};
  width: 100%;
  background: #fafafb;
  z-index: 99;
  position: sticky !important;
  top: 0 !important;
  padding-bottom: 10px;
`
export const Main = styled.div`
  position: sticky;
  top: 0;
  z-index: 1001;
`
export const LeftSection = styled(Flex)`
  gap: 20px;
`
export const RightSection = styled(Flex)`
  gap: 20px;
`
export const SectionName = styled(Flex)`
  gap: 10px;
`

export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #4d566e;
`
export const BreadMainSpan = styled.span`
font-family: Plus Jakarta Sans;
font-size: 12px;
font-weight: 500;
color : #000000;`

export const BreadSubSpan = styled.span`
font-family: Plus Jakarta Sans;
font-size: 12px;
font-weight: 500;
color : #3249D7;`
